var PDFBlock = require("./block");
var util = require("./util");
var SCOPE_MAP = {
    row: "/Row",
    col: "/Column",
    both: "/Both",
};
function PDFTableCell(options, children) {
    PDFBlock.call(this, options, children);
    this.verticalAlign = util.getOption(options, "verticalAlign", "auto");
    this.colSpan = util.getOption(options, "colSpan", 1);
    this.rowSpan = util.getOption(options, "rowSpan", 1);
    this.scope = util.getOption(options, "scope", null);
    this.width = "auto";
}
util.inherits(PDFTableCell, PDFBlock);
PDFTableCell.prototype.fixBorders = function (cursor) {
    if (!this.adjCells)
        throw new Error("Something went wrong");
    var adjCells = this.adjCells;
    var borderTopWidth = util.getOption(this.options, "borderTopWidth", this.borderWidth);
    var borderLeftWidth = util.getOption(this.options, "borderLeftWidth", this.borderWidth);
    var borderRightWidth = util.getOption(this.options, "borderRightWidth", this.borderWidth);
    var borderBottomWidth = util.getOption(this.options, "borderBottomWidth", this.borderWidth);
    if (adjCells.left && adjCells.left.borderRightWidth >= borderLeftWidth) {
        this.borderLeftWidth = adjCells.left.borderRightWidth;
        this.borderLeftColor = adjCells.left.borderRightColor;
    }
    else {
        this.borderLeftWidth = borderLeftWidth;
        this.borderLeftColor = util.getOption(this.options, "borderLeftColor", this.borderColor);
    }
    if (adjCells.right && adjCells.right.borderLeftWidth > borderRightWidth) {
        this.borderRightWidth = adjCells.right.borderLeftWidth;
        this.borderRightColor = adjCells.right.borderLeftColor;
    }
    else {
        this.borderRightWidth = borderRightWidth;
        this.borderRightColor = util.getOption(this.options, "borderRightColor", this.borderColor);
    }
    if (!cursor._firstOfPage && adjCells.top && adjCells.top.borderBottomWidth >= borderTopWidth) {
        this.borderTopWidth = adjCells.top.borderBottomWidth;
        this.borderTopColor = adjCells.top.borderBottomColor;
    }
    else {
        this.borderTopWidth = borderTopWidth;
        this.borderTopColor = util.getOption(this.options, "borderTopColor", this.borderColor);
    }
    if (!cursor._lastOfPage && adjCells.bottom && adjCells.bottom.borderTopWidth > borderBottomWidth) {
        this.borderBottomWidth = adjCells.bottom.borderTopWidth;
        this.borderBottomColor = adjCells.bottom.borderTopColor;
    }
    else {
        this.borderBottomWidth = borderBottomWidth;
        this.borderBottomColor = util.getOption(this.options, "borderBottomColor", this.borderColor);
    }
};
PDFTableCell.prototype.fixedCursor = function (cursor) {
    this.fixBorders(cursor);
    return {
        x: cursor.x - this.borderLeftWidth / 2,
        y: cursor.y - this.borderTopWidth / 2,
        width: cursor.width + this.borderLeftWidth / 2 + this.borderRightWidth / 2,
        height: cursor.height + this.borderTopWidth / 2 + this.borderBottomWidth / 2,
        doc: cursor.doc,
        _firstOfPage: cursor._firstOfPage,
        _lastOfPage: cursor._lastOfPage,
        _drawBorders: {
            top: true,
            left: true,
            right: !this.adjCells.right,
            bottom: !this.adjCells.bottom || cursor._lastOfPage,
        },
    };
};
PDFTableCell.prototype.calc = function (cursor) {
    return PDFBlock.prototype.calc.call(this, this.fixedCursor(cursor));
};
PDFTableCell.prototype.draw = function (cursor) {
    var _origPaddingTop = this.paddingTop, _origHeight = this.height, measureCell = this.calc(cursor), extra = Math.max(0, cursor._rowHeight - measureCell._innerHeight - _origPaddingTop - this.paddingBottom);
    if (this.verticalAlign === "middle") {
        this.paddingTop = _origPaddingTop + extra / 2;
    }
    else if (this.verticalAlign === "bottom") {
        this.paddingTop = _origPaddingTop + extra;
    }
    this.height = cursor._rowHeight;
    if (cursor._tableRole !== "table" && (this.role === "table-cell" || this.role === "table-heading")) {
        this.role = "none";
    }
    var a11yAttr = {};
    if (this.role === "table-heading" && this.scope && SCOPE_MAP[this.scope]) {
        a11yAttr.Scope = SCOPE_MAP[this.scope];
    }
    if (this.colSpan > 1)
        a11yAttr.ColSpan = this.colSpan;
    if (this.rowSpan > 1)
        a11yAttr.RowSpan = this.rowSpan;
    if (Object.keys(a11yAttr).length) {
        a11yAttr.O = "/Table";
        this.a11yAttr = a11yAttr;
    }
    var ret = PDFBlock.prototype.draw.call(this, this.fixedCursor(cursor));
    this.paddingTop = _origPaddingTop;
    this.height = _origHeight;
    return ret;
};
module.exports = PDFTableCell;
//# sourceMappingURL=module.js.map